import { FileParameter } from "../web-api-client";

  export class EmbeddedEnvelope {
    SignerName: string;
    SignerEmail: string;
    SignerClientId: string;
    ReturnUrl: string;
    DocPdf: FileParameter;
  };